import { render, staticRenderFns } from "./PanelDetailInfo.vue?vue&type=template&id=48acf94a&scoped=true"
import script from "./PanelDetailInfo.vue?vue&type=script&lang=js"
export * from "./PanelDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./PanelDetailInfo.vue?vue&type=style&index=0&id=48acf94a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48acf94a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48acf94a')) {
      api.createRecord('48acf94a', component.options)
    } else {
      api.reload('48acf94a', component.options)
    }
    module.hot.accept("./PanelDetailInfo.vue?vue&type=template&id=48acf94a&scoped=true", function () {
      api.rerender('48acf94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/list/common/PanelDetailInfo.vue"
export default component.exports